import type { QueryClient } from "@tanstack/react-query";

/**
 * A handle on the live query client for code that runs outside the React tree.
 *
 * Logout and the 401 handler both have to drop cached data — without that, the
 * next person to sign in on this browser briefly sees the previous user's rows.
 * Neither can call `useQueryClient()`, so `QueryProvider` registers the
 * instance here as it creates it.
 *
 * Lives in its own module so `QueryProvider.tsx` keeps exporting only a
 * component, which is what React Fast Refresh requires.
 */
let queryClient: QueryClient | null = null;

export const setActiveQueryClient = (client: QueryClient): void => {
  queryClient = client;
};

/** `null` until the provider has mounted. */
export const getActiveQueryClient = (): QueryClient | null => queryClient;
